import { render } from "./HistoryOrder.vue?vue&type=template&id=bf987436&scoped=true"
import script from "./HistoryOrder.vue?vue&type=script&lang=js"
export * from "./HistoryOrder.vue?vue&type=script&lang=js"

import "./HistoryOrder.vue?vue&type=style&index=0&id=bf987436&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf987436"]])

export default __exports__